import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tenant-selector", class: { readonly: _vm.readonly } },
    [
      _c("div", { staticClass: "tenant-label" }, [
        _vm._v(_vm._s(_vm.$t("navBar.tenant"))),
      ]),
      _vm._v(" "),
      _c(VSelect, {
        attrs: {
          items: _vm.tenants,
          "item-text": "name",
          "item-value": "key",
          "hide-details": "",
          readonly: _vm.readonly,
        },
        on: { change: _vm.setTenant },
        model: {
          value: _vm.currentTenant,
          callback: function ($$v) {
            _vm.currentTenant = $$v
          },
          expression: "currentTenant",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }